
<template lang="pug">
  .promo-bar
    .container.container--promo
      .promo-bar__text.u-text-center(
        v-html="text"
      )
      .promo-bar__menu
        a.promo-bar__menu-link(
          v-for="link in links"
          :key="link.title"
          :href="baseURL + link.url"
        ) {{ link.title }}
</template>

<script>
  import { openChatWidget } from 'scripts/helpers/zendesk.js';

  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'PromoBar',
    components: {
      Icon,
    },
    props: {
      text: String,
      promoLink: String,
      links: Array,
    },
    mounted () {
      document.body.classList.add('has-promobar');
    },
    methods: {
      openHelp () {
        openChatWidget();
      },
    },
    computed: {
      // required to fix chrome throwing a invalid URL console error
      baseURL () {
        return window.location.origin;
      },
    }
  };
</script>

<style scoped lang="scss">
  .promo-bar {
    position: fixed;
    top: 0;
    left: 0;
    padding: 8px 0;
    width: 100%;
    background-color: $color-pink;
    color: $color-indigo;

    .promo-bar__menu {
      display: none;

      @include desktop-up() {
        display: block;
        position: absolute;
        right: $grid-gutter;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    .container--promo {
      position: relative;
    }

    .promo-bar__menu-link {
      margin-left: $grid-gutter;
      font-size: rem(14);
      line-height: 18px;
      font-family: $font-gibson;
      color: $color-indigo;

      &:hover {
        text-decoration: underline;
      }
    }

    &::v-deep + .navbar .navbar__mobile {
      top: $mobile-promobar-height;
    }

    @include desktop-up {
      padding: 9px 0;
      position: relative;
    }

    &__text {
      margin: 0;
      padding-bottom: 1px;
      font-size: rem(15);
      line-height: 1;
      letter-spacing: 1px;
      font-family: $font-acumin-pro;
      font-weight: 700;
      text-transform: uppercase;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      ::v-deep p {
        margin: 0;
        font-size: inherit;
        font-family: inherit;
      }

      ::v-deep a {
        text-decoration: underline;
      }
    }
  }
</style>
